import React, { useMemo, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { EncodeURIComponentSafe, GroupByKey, StudentIDFormat } from "../../../../Library/GlobalHelper";

export function TableCounseling({ data, activeTab }) {
  const ResultData = useMemo(() => {
    let computedData = [];
    if (activeTab === 0) {
      // All
      // const all_data = data.filter((item) => item.student_activity.id !== "asc.student.activity.notactive");
      computedData = GroupByKey(data, "studentid");
    } else if (activeTab === 1) {
      // Pending Approval
      const pending = data.filter((item) => item.event_status === "SUBMITTED");
      computedData = GroupByKey(pending, "studentid");
    } else if (activeTab === 2) {
      // Approved
      const approved = data.filter((item) => item.event_status === "PROCESSED");
      computedData = GroupByKey(approved, "studentid");
    } else if (activeTab === 3) {
      // Canceled
      const canceled = data.filter((item) => item.event_status === "CANCELLED");
      computedData = GroupByKey(canceled, "studentid");
    } else if (activeTab === 4) {
      // Not Activity
      const no_act = data.filter(
        (item) => item.student_activity.id === "asc.student.activity.notactive"
      );
      computedData = GroupByKey(no_act, "studentid");
    }

    return computedData;
  }, [data, activeTab]);

  return (
    <div className="card card-custom card-stretch gutter-b ">
      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table table-head-custom table-head-bg table-border table-vertical-center">
            <thead>
              <tr>
                <th>Student</th>
                <th>Activity Type</th>
                <th width="15%">Status</th>
                <th>Request Date</th>
                <th>Detail</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(ResultData).length > 0 ? (
                Object.keys(ResultData).map((k, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr key={index}>
                        <td
                          className=""
                          rowSpan={
                            Object.values(ResultData[k]).length > 0
                              ? Object.values(ResultData[k]).length + 1
                              : 1
                          }
                        >
                          <Link
                            to={{
                              pathname:
                                "/counseling/student/" + k + "/academic",
                            }}
                          >
                            <span className="mr-1">
                              {k && StudentIDFormat(k)}
                            </span>
                            <span>
                              {(ResultData[k][0] &&
                                ResultData[k][0]?.studentstatusdata
                                  ?.fullname) ||
                                "-"}
                            </span>
                          </Link>
                        </td>
                      </tr>
                      {ResultData[k] &&
                      Array.isArray(ResultData[k]) &&
                      ResultData[k].length > 0 ? (
                        ResultData[k].map((v, index) =>
                          v.student_activity ? (
                            <tr key={index}>
                              <td className="font-weight-bolder">
                                <span className={`badge badge-${v.student_activity.id.includes('pcf') ? 'success':'light'}`}  style={{ fontSize: "12px" }}>{v?.student_activity?.name || ""}</span>
                                <span className="mx-1">·</span>
                                <span>{v?.atp?.name} </span>
                              </td>
                              <td>
                                <StatusActivity
                                  act_type={v?.student_activity?.id}
                                  status={v?.event_status}
                                />
                              </td>
                              <td>
                                {v.submit_date
                                  ? moment(v.submit_date).format(
                                      "DD MMM YYYY hh:mm a"
                                    )
                                  : ""}
                              </td>
                              <td>
                                <ButtonAction data={v} />
                                {v.student_activity.id.includes('leave') && v.note ? <ButtonNotes note={v.note} /> : ""}
                              </td>
                            </tr>
                          ) : (
                            <tr key={index}>
                              <td></td>
                              <td colSpan={4}>-</td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td colSpan={5}>No record found</td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5}>No record found</td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
}

const StatusActivity = ({ act_type, status }) => {
  let status_name = "",
    color = "",
    icon = "";
  switch (status) {
    case "PROCESSED":
      status_name = "APPROVED";
      color = "primary";
      icon = "check text-white";
      break;
    case "SUBMITTED":
      status_name = "PENDING APPROVAL";
      color = "warning";
      icon = "clock text-dark";
      break;
    default:
      status_name = status;
      color = "light";
      icon = "info-circle text-dark";
      break;
  }

  if (status_name) {
    return (
      <span className={`badge badge-${color} d-flex align-items-center`}>
        <i className={`fa fa-${icon} mr-3`}></i>
        <span className="font-weight-bold" style={{ fontSize: "12px" }}>
          {status_name} {act_type.includes("resign") && <span>By AOO</span>}
        </span>
      </span>
    );
  } else {
    return "";
  }
};

const ButtonAction = ({ data }) => {
  console.log(data);
  const act_type = data?.student_activity?.id || "";
  if (
    act_type.includes("pcf") ||
    act_type.includes("short") ||
    act_type.includes("leave")
  ) {
    return (
      <Link
        to={{
          pathname:
            "/counseling/student/" +
            data.studentid +
            "/activity/"+EncodeURIComponentSafe(data.eventid)
        }}
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
      >
        <i className="fa fa-arrow-right"></i>
      </Link>
    );
  } else {
    return "";
  }
};

const ButtonNotes = ({ note }) => {
  const [open, setOpen] = useState(false);
  return (
    <button className="btn btn-sm" onClick={() => setOpen(!open)}>
      <i className="flaticon-notes text-warning"></i>
      {open ? note : ""}
    </button>
  );
};
